import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { ReactElement, useEffect, useState } from 'react';

import FertilizationTable from '@/modules/periodicJobs/components/FertilizationTable';
import Header from '@/modules/periodicJobs/components/Header';
import RangeDatePicker from '@/modules/periodicJobs/components/RangeDatePicker';
import SelectedLoactions from '@/modules/periodicJobs/components/SelectedLoactions';
import WorkLocation from '@/modules/periodicJobs/components/WorkLocation';
import { PeriodicJobsProvider } from '@/modules/periodicJobs/context/context';
import { Loading } from '@/shared/components/atoms';
import Tabs from '@/shared/components/atoms/Tabs';
import { EntityType } from '@/shared/constant/enums';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import SprayingComingSoon from '~/images/periodicJobs/sprayingComingSoon.svg';

const TAB_QUERY_INDICATORE = 'job';

const PeriodicJobs = (): ReactElement => {
  const [fertilizationCount, setFertilizationCount] = useState(0);

  const router = useRouter();

  const { t } = useTranslation('common');

  const [selectedAsset] = useStore((store) => store?.asset);

  const setFertilizationCountHandler = (count: number) => {
    setFertilizationCount(count);
  };

  const tabsList = [
    { label: t('fertilization'), value: 1, count: fertilizationCount },
    { label: t('spraying'), value: 2, count: 0 },
  ];

  const showPeriodicJobs =
    // selectedAsset?.companyTypeId === CompanyType.COMPANY &&
    selectedAsset?.entityTypeId === EntityType.FARM;

  const selectedTab = router.query[TAB_QUERY_INDICATORE];

  useEffect(() => {
    if (!showPeriodicJobs) {
      router.replace('/');
    }
  }, [showPeriodicJobs, router]);

  if (!showPeriodicJobs) {
    return (
      <div className='mt-125 flex h-full flex-col items-center justify-center'>
        <Loading />
      </div>
    );
  }

  return (
    <PeriodicJobsProvider>
      <section className='pb-7'>
        <Header entityId={selectedAsset?.id} />
        <Tabs
          getValue={(item) => item.value}
          getLabel={(item) => `${item.label} (${item.count})`}
          tabsList={tabsList}
          variant='underline'
          tabQueryIndicator={TAB_QUERY_INDICATORE}
          containerClassName='border-b-sm border-neutralVariant-90'
        />
        {selectedTab === '1' && (
          <>
            <div className='mb-8 mt-16 flex items-center justify-between'>
              <WorkLocation entityId={selectedAsset?.id} />
              <RangeDatePicker />
            </div>
            <SelectedLoactions />
            <FertilizationTable
              entityId={selectedAsset?.id}
              setFertilizationCount={setFertilizationCountHandler}
            />
          </>
        )}
        {selectedTab === '2' && (
          <div className='flex h-full flex-col items-center justify-center laptop:mt-125'>
            <SprayingComingSoon className='h-260 w-343' />
            <p className='text-30 font-bold text-primary-default'>
              {t('comingSoon')}
            </p>
          </div>
        )}
      </section>
    </PeriodicJobsProvider>
  );
};

export default PeriodicJobs;
